export enum ArrowAngle {
	TOP = 'go-tooltip-arrow-top',
	BOTTOM = 'go-tooltip-arrow-bottom',
	RIGHT = 'go-tooltip-arrow-right',
	LEFT = 'go-tooltip-arrow-left',
}
